<script>
export default {
  name: "Habitacion",
  props: {
    value: { type: Object, required: true },
  },
};
</script>

<template>
  <tr>
    <th colspan="3">
      <div class="habitacion-cabecera">
        <small>{{ value.numero }}<span v-html="'&deg;'"/></small> <span v-html="'Habitaci&oacute;n:&nbsp;'"/>
        <b>{{ value.nombre }}</b>
        <input
          type="hidden"
          :name="'habitaciones[' + value.numero + '][num]'"
          :value="value.numero"
        />
        <input
          type="hidden"
          :name="'habitaciones[' + value.numero + '][base]'"
          :value="value.base"
        />
      </div>

      <Pasajero
        v-for="(pasajero, paxKey) in value.pasajeros"
        :key="value.base + '_' + value.numero + '_' + pasajero.numero"
        v-model="value.pasajeros[paxKey]"
        :habitacion-numero="value.numero"
      />
    </th>
  </tr>
</template>

<style scoped>
th {
  padding: 0;
}
th {
  border-top: 0!important;
}
.habitacion-cabecera {
  padding: 5px;
  border-color: #2980b9;
  background: #2980b9;
  color: #ffffff;
}
</style>